import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { SlotInfoDto } from '@shared/src/dtos/address/slots/SlotInfoDto';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/public-api';
import { MultiSlotInfoDto } from '@shared/src/dtos/address/slots/MultiSlotInfoDto';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';

@Component({
  selector: 'shared-exwork-slot-viewer-component',
  templateUrl: './shared.exwork.slot.viewer.component.html',
  styleUrls: ['./shared.exwork.slot.viewer.component.scss'],
})
export class SharedExworkSlotViewerComponent {

  public useIonic: boolean = false;

  constructor(@Inject('SecurityController') protected securityController: SecurityController,
    protected openRouteController: OpenRouteController, @Inject('HomeController') protected homecontroller: HomeController) {

  }

  @Input()
  public driver: boolean = false;

  @Input()
  public allowNextView: boolean = true;

  public __uuid: string;
  @Input()
  public set uuid(value: string) {
    if (this.__uuid == value)
      return;
    this.__uuid = value;
  }
  public get uuid(): string {
    return this.__uuid;
  }

  public __slotInfo: SlotInfoDto;
  @Input()
  set slotInfo(value: SlotInfoDto) {
    if (this.__slotInfo == value)
      return;
    this.__slotInfo = value;
    this.loadMultiSlotInfo();
    this.wellcome();
  }
  get slotInfo(): SlotInfoDto {
    return this.__slotInfo;
  }

  public multiSlotInfo: MultiSlotInfoDto;

  @Output()
  public callBack: EventEmitter<any> = new EventEmitter();

  public view: number = 0;
  public nextView(event) {
    if (!this.allowNextView)
      return;
    this.view++;
    this.wellcome();

  }

  public tooltip = "";
  public generalClass = "";
  public wellcome() {
    this.generalClass = "";
    if (this.slotInfo == null) {
    }
    else {
      if (this.slotInfo.noShow)
        this.generalClass = " noShow";
      if (this.slotInfo.isBlockedBookSlotSystem)
        this.generalClass += " isBlockedBookSlotSystem";
      else
        this.generalClass += " noIsBlockedBookSlotSystem";
      if (this.slotInfo.isBlockedEnterSystem)
        this.generalClass += " isBlockedEnterSystem";
      else
        this.generalClass += " noisBlockedEnterSystem";
      if (this.slotInfo.isBlockedExitSystem)
        this.generalClass += " isBlockedExitSystem";
      else
        this.generalClass += " noisBlockedExitSystem";
      if (this.slotInfo.isSlotBlocked)
        this.generalClass += " isSlotBlocked";
      else
        this.generalClass += " noIsSlotBlocked";
      if (this.slotInfo.isSlotBlockedExternal)
        this.generalClass += " isSlotBlockedExternal";
      else
        this.generalClass += " noIsSlotBlockedExternal";

      if (this.slotInfo.slotId && this.slotInfo.slotId > 0)
        this.generalClass += " ambslot";
      else if (!this.slotInfo.slotId || this.slotInfo.slotId == 0)
        this.generalClass += " senseslot";

      if (this.slotInfo.incompatibleSlot)
        this.generalClass += " incompatibleSlot";

      if (this.slotInfo.isLateAtSlot)
        this.generalClass += " isLateAtSlot";

      this.generalClass += " noExplicat";

      if (this.slotInfo.pendingSlotQty && this.slotInfo.pendingSlotQty > 0)
        this.generalClass += " ambPendingSlotQty";

      if (this.slotInfo.slotStatus)
        this.generalClass += " " + this.slotInfo.slotStatus;

      if (this.view % 3 === 0)
        this.generalClass += " documentation";

      if (this.view % 3 === 1)
        this.generalClass += " dock";

      if (this.view % 3 === 2)
        this.generalClass += " lift";

    }
  }

  loadMultiSlotInfo() {
    if (this.slotInfo == null || !this.slotInfo.multiSlot) {
      this.multiSlotInfo = null;
      return;
    }

    if (this.driver)
      this.openRouteController.getMultiSlotInfoDriver(this.slotInfo.slotId).subscribe(data => {
        this.multiSlotInfo = data;
      });
    else
      this.openRouteController.getMultiSlotInfoExwork(this.uuid, this.slotInfo.slotId).subscribe(data => {
        this.multiSlotInfo = data;
      });
  }


  OnInit() {
  }

  public pretty(value) {
    return JSON.stringify(value);
  }
}
